import React, { Suspense } from 'react';
import { PreviewAssetsStepShimmer } from '@bingads-webui-campaign-react/pmax-lite-shimmers';

const DelayedPreviewAssetsStep =
  React.lazy(() => import(/* webpackChunkName: "preview-assets-step.async" */ './preview-assets-step')
    .then(({ PreviewAssetsStepWithI18n }) => ({
      default: PreviewAssetsStepWithI18n,
    })));

export const DelayedPreviewAssetsStepWithI18n = () => (
  <Suspense fallback={<PreviewAssetsStepShimmer />}>
    <DelayedPreviewAssetsStep />
  </Suspense>
);
